import { ImageModel } from '../General';
import { SelectOption } from '../General/Select';

export enum DamageExceptionType {
  FporDamage,
  MaintenanceException,
  AdHocDamage,
}

export enum DamageExceptionStatus {
  Open,
  InReview,
  Actioned,
  Closed,
}

export interface DamageExceptionModel {
  id: number;
  type: string;
  typeDescription: string;
  referenceId: number;
  vin: string;
  customerId: number;
  customerName: string;
  subCustomerId?: number;
  subCustomerName: string;
  locationId?: number;
  location?: string;
  status: string;
  statusDescription: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface DamageExceptionFilterData {
  types: SelectOption<string>[];
  statuses: SelectOption<string>[];
  customers: SelectOption<number>[];
  subCustomers: SelectOption<number>[];
  locations: SelectOption<number>[];
}

export interface DamageExceptionDetailModel {
  detail: DamageExceptionModel;
  originalInfo: any;
  vehicle: DamageExceptionVehicleModel;
  notes: DamageExceptionNoteModel[];
  actions: DamageExceptionActionModel[];
  jobs: DamageExceptionJobModel[];
  images: ImageModel[];
  attachments: ImageModel[];
}

export interface DamageExceptionNoteModel {
  note: string;
  createdAt: string;
  createdBy: string;
}

export interface DamageExceptionActionModel {
  job: DamageExceptionJobModel;
  createdAt: string;
  createdBy: string;
}

export interface DamageExceptionJobModel {
  jobId: number;
  jobTypeDescription: string;
  createdAt: string;
  createdBy: string;
}

export interface DamageExceptionVehicleModel {
  vin: string;
  manufacturer: string;
  manufactureDate: string;
  model: string;
  colour: string;
  regNumber: string;
  locationDesc: string;
  location: string;
  vinStatus: string;
  vinStatusDesc: string;
}

export interface CreateDamageExceptionNoteForm {
  damageExceptionId: number;
  note: string;
}

export interface CreateDamageExceptionActionForm {
  damageExceptionId: number;
  jobId: number;
}

export interface UpdateDamageExceptionStatusForm {
  damageExceptionId: number;
  status: DamageExceptionStatus;
}

export interface UploadDamageExceptionAttachmentForm {
  damageExceptionId: number;
  fileName: string;
  fileBase64: string;
}
